import { configureStore } from "@reduxjs/toolkit";
import authSlice from "../slices/authSlice";
import { gradeFileSlide } from "../slices/gradeFileSlide";
import { themeWrapperSlice } from "../slices/themeWrapperSlice";
import practiceRoomSlide from "../slices/practiceRoomSlice";
import notesSlice from "../slices/notesSlice";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    gradeFile: gradeFileSlide.reducer,
    themeWrapper: themeWrapperSlice.reducer,
    practiceRoom: practiceRoomSlide.reducer,
    notes: notesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
